import { LabProvider } from '../../../../api/generated-catch-backend/model';

/**
 * Display names for lab providers
 * Used as fallback when backend doesn't provide labName
 */
export const LAB_DISPLAY_NAMES: Record<LabProvider, string> = {
  [LabProvider.quest]: 'Quest Diagnostics',
  [LabProvider.labcorp]: 'LabCorp',
  [LabProvider.bioreference]: 'BioReference',
} as const;

/**
 * Get the display name for a lab provider
 * @param provider - The lab provider enum value
 * @returns Display name or generic fallback
 */
export function getLabDisplayName(provider: LabProvider | null | undefined): string {
  if (!provider) {
    return 'Lab Provider';
  }
  return LAB_DISPLAY_NAMES[provider] || 'Lab Provider';
}
